<template>
    <div class="page" id="playerBookVideoLesson">
        <header class="pageHeader rounded">
            <fade-image class="darken" src="assets/headers/lessons.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Lesson Booking</h2>
                <ul class="links">
                    <li>
                        <a class="cancel" @click.prevent="$router.back()" href="#">
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <button
                type="button"
                name="button"
                class="button light left"
                @click.prevent="$router.back()"
            >
                Video lesson
                <img class="arrow" src="~@/assets/arrow-right-green.svg" />
            </button>

            <span class="info mb10" style="background-color: #f6d5a6">
                Please upload 2 swing videos, one square on and the other down the line. For a guide
                to setting up your videos please
                <a
                    @click.prevent="
                        openExternalTab('https://lessonpro.co.uk/setting-up-swing-videos/')
                    "
                    href="https://lessonpro.co.uk/setting-up-swing-videos/"
                    class="link"
                    target="_blank"
                    >click here</a
                >.
            </span>

            <form class="form3" @submit.prevent="makeBooking">
                <video-upload
                    v-model="form.video1"
                    class="video"
                    :editMode="!form.busy"
                    display-name="1"
                    @isUploadingChanged="onUploadingStateChanged1"
                >
                    <div class="video-field-block">
                        <img
                            class="video-placeholder-image"
                            src="@/assets/videolesson/video1-placeholder.jpg"
                        />
                        <div class="video-field-block-content">
                            <h3>
                                Video 1:<br />
                                Square on
                            </h3>
                            <p>Please use alignment sticks if available</p>
                        </div>
                    </div>
                </video-upload>

                <video-upload
                    v-model="form.video2"
                    class="video"
                    :editMode="!form.busy"
                    display-name="2"
                    @isUploadingChanged="onUploadingStateChanged2"
                >
                    <div class="video-field-block">
                        <img
                            class="video-placeholder-image"
                            src="@/assets/videolesson/video2-placeholder.jpg"
                        />
                        <div class="video-field-block-content">
                            <h3>
                                Video 2:<br />
                                Down the line
                            </h3>
                            <p>Please use alignment sticks if available</p>
                        </div>
                    </div>
                </video-upload>

                <template>
                    <span class="info mb10">
                        Send a brief description of your ball flight and what you want help with
                    </span>

                    <div class="formGroup">
                        <textarea
                            :class="{ selected: form.note }"
                            name="name"
                            v-model="form.note"
                            :disabled="form.busy"
                            style="background: #fff"
                            placeholder="Tap here to add a note"
                        ></textarea>
                    </div>
                </template>

                <div class="booking-price">
                    {{
                        (user.lesson_settings.video_lessons_price / 100)
                            | currency({
                                symbol: user.currencySymbol,
                            })
                    }}
                </div>

                <span class="info mb10">
                    This will deduct
                    {{
                        (user.lesson_settings.video_lessons_price / 100)
                            | currency({
                                symbol: user.currencySymbol,
                            })
                    }}
                    from your payment card we have saved on file ending
                    {{ user.stripe_card }}.
                </span>

                <button
                    :disabled="form.busy || !form.video1 || !form.video2"
                    style="margin-bottom: 20px"
                    class="button"
                    type="submit"
                    name="button"
                >
                    {{
                        form.busy
                            ? "Please wait..."
                            : isUploading
                              ? "Please wait, uploading videos..."
                              : "Pay for lesson"
                    }}
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
import { Form } from "vform";
import VideoUpload from "@/components/Shared/Book-video-lesson/Video-upload";
import { imageURL } from "@/mixins/imageURL.js";
import { isBrowser } from "mobile-device-detect";

export default {
    name: "book-video-lesson",
    components: {
        FadeImage,
        XIcon,
        VideoUpload,
    },
    mixins: [imageURL],
    computed: {
        user() {
            return this.$store.state.user;
        },
        isUploading() {
            return this.isUploading1 || this.isUploading2;
        },
    },
    mounted() {
        this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY);
    },
    data() {
        return {
            oWebViewInterface: window.nsWebViewInterface,
            stripe: false,
            record: {},
            noteOpen: false,
            isUploading1: false,
            isUploading2: false,
            form: new Form({
                player_id: "",
                video1: null,
                video2: null,
                note: "",
                payment_intent_id: null,
            }),
        };
    },
    methods: {
        openExternalTab(url) {
            if (isBrowser) {
                window.open(url);
            } else {
                this.oWebViewInterface.emit("openExternalTab", url);
            }
        },
        onUploadingStateChanged1(isUploading) {
            this.isUploading1 = isUploading;
        },
        onUploadingStateChanged2(isUploading) {
            this.isUploading2 = isUploading;
        },
        makeBooking() {
            var self = this;
            this.form
                .post("/videobooking")
                .then(() => {
                    this.$notify({
                        text: "Your video lesson has been requested",
                    });
                    this.$router.push({ name: "playerLessons" });
                    // this.$router.push({
                    //     name: "BookLessonConfirmation",
                    //     params: { id: response.data.lesson.id },
                    // });
                })
                .catch(function (e) {
                    if (e.response.data.code == "authentication_required") {
                        self.authStripe(e.response.data);
                    } else {
                        let errorMessage =
                            "There was a problem processing your request. Please try again later.";
                        if (e.response && e.response.data && e.response.data.message) {
                            errorMessage = e.response.data.message;
                        }
                        self.$notify({
                            type: "error",
                            text: errorMessage,
                        });
                    }
                });
        },
        authStripe(stripeResponse) {
            this.form.busy = true;
            this.stripe
                .confirmCardPayment(stripeResponse.intent.client_secret, {
                    payment_method: stripeResponse.intent.last_payment_error.payment_method.id,
                })
                .then((result) => {
                    if (result.error) {
                        // Show error to your customer
                        this.$notify({
                            type: "error",
                            text: result.error.message,
                        });
                        this.form.busy = false;
                    } else {
                        if (result.paymentIntent.status === "succeeded") {
                            this.form.payment_intent_id = result.paymentIntent.id;
                            this.makeBooking();
                        }
                    }
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.link {
    color: $green_0;
    text-decoration: none;
    font-weight: bold;
}
.booking-price {
    text-align: center;
    color: $green_0;
    font-size: 32px;
    padding-top: 10px;
    padding-bottom: 30px;
}
.video {
    background: #e7efeb;
}
.video-field-block {
    display: flex;
    align-items: center;
    justify-content: center;

    .video-placeholder-image {
        margin: 15px 0 15px 10px;
    }

    .video-field-block-content {
        padding: 20px;
        h3 {
            font-weight: 500;
            font-size: 22px;
            line-height: 28px;
            color: #939a93;
        }
        p {
            font-size: 14px;
            line-height: 24px;
            padding-top: 10px;
            font-weight: 500;
            color: $green_0;
        }
    }
}
.button {
    margin-bottom: 10px;
    &.complete {
        background: white;
        color: $green_0;
    }
    .arrow {
        position: absolute;
        right: 20px;
        top: 20px;
    }
}

p {
    line-height: 1.5;
    color: $green_0;
}
.select {
    .arrow {
        position: absolute;
        right: 20px;
        top: 20px;
    }
    .button {
        padding-left: 17px !important;
    }
}
p {
    font-weight: 200;
    font-size: 14px;
}
</style>
